import { Col, Form } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import { CustomFloatingLabel } from "./customfloatinglabel.jsx";
import { StyledTextArea } from "./base/styledtextarea.jsx";
import { useTranslation } from "react-i18next";

export const FormTextArea = ({
  name,
  label,
  formGroupProps,
  textAreaProps,
  required,
  disabled,
  customErrorMessage,
  additionalClassnames,
}) => {
  const { control } = useFormContext();
  const { t } = useTranslation();

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: required }}
      render={({
        field: { value, onChange, disabled: globalDisabled, onBlur, ref },
        fieldState: { error, isDirty },
      }) => {
        const errorType = error?.type;

        const helperText = () => {
          if (errorType === "required" || errorType === undefined) {
            return t("FieldRequired", "Kenttä on pakollinen");
          }
          return errorType && customErrorMessage?.[errorType]
            ? customErrorMessage[errorType]
            : error?.message;
        };

        return (
          <Form.Group
            required={required}
            as={Col}
            xs={12}
            className={`d-flex flex-column mb-2 ${additionalClassnames ?? ""}`}
            {...formGroupProps}
          >
            <CustomFloatingLabel label={`${label} ${required ? " *" : ""}`}>
              <StyledTextArea
                value={value}
                onChange={onChange}
                as="textarea"
                required={required}
                rows={4}
                active={isDirty}
                onBlur={onBlur}
                disabled={disabled || globalDisabled}
                ref={ref}
                placeholder={`${label} ${required ? " *" : ""}`}
                {...textAreaProps}
              />
            </CustomFloatingLabel>
            {error && (
              <Form.Control.Feedback type="invalid" className="d-block mb-1">
                {helperText()}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        );
      }}
    />
  );
};
